
    var riot = require('riot')
    //src: starling/src/tags/link-direction-menu.html
riot.tag2('link-direction-menu',
  '<ul class="menu-list"> <li onclick="{this.changeRDirection.bind(null,\'none\')}"> <span class="arrow-container"> <div class="arrow r-left}"> <svg class="line-preview"> <path id="menu-arrow-path-none" d="M 4 8 L 56 8" stroke-dasharray="{this.getLinePreviewStyle()}" stroke-width="{this.getLinePreviewWidth()}" stroke="{this.getLinePreviewColor(\'none\')}"></path> </svg> </div> </li> <li onclick="{this.changeRDirection.bind(null,\'left\')}"> <span class="arrow-container"> <div class="arrow r-left"> <svg class="line-preview"> <path id="menu-arrow-path-left" d="M 8 8 L 56 8" stroke-dasharray="{this.getLinePreviewStyle()}" stroke-width="{this.getLinePreviewWidth()}" stroke="{this.getLinePreviewColor(\'left\')}"></path> <text class="to backing arrow"> <textpath xlink:href="#menu-arrow-path-left" startoffset="0px"> <tspan x="0" y="0" riot-style="{`fill: ${this.getLinePreviewColor(\'left\')}`}">&#xe900;</tspan> </textPath> </text> </svg> </div> </li> <li onclick="{this.changeRDirection.bind(null,\'right\')}"> <div lass="arrow r-right"> <svg class="line-preview"> <path id="menu-arrow-path-right" d="M 4 8 L 52 8" stroke-dasharray="{this.getLinePreviewStyle()}" stroke-width="{this.getLinePreviewWidth()}" stroke="{this.getLinePreviewColor(\'right\')}"></path> <text class="from backing arrow" text-anchor="end"> <textpath xlink:href="#menu-arrow-path-right" startoffset="100%"> <tspan x="0" y="0" riot-style="{`fill: ${this.getLinePreviewColor(\'right\')}`}">&#xe901;</tspan> </textPath> </text> </svg> </div> </span> </li> <li onclick="{this.changeRDirection.bind(null,\'both\')}"> <div class="arrow r-right"> <svg class="line-preview"> <path id="menu-arrow-path-both" d="M 8 8 L 52 8" stroke-dasharray="{this.getLinePreviewStyle()}" stroke-width="{this.getLinePreviewWidth()}" stroke="{this.getLinePreviewColor(\'both\')}"></path> <text class="to backing arrow"> <textpath xlink:href="#menu-arrow-path-left" startoffset="0px"> <tspan x="0" y="0" riot-style="{`fill: ${this.getLinePreviewColor(\'both\')}`}">&#xe900;</tspan> </textPath> </text> <text class="from backing arrow" text-anchor="end"> <textpath xlink:href="#menu-arrow-path-right" startoffset="100%"> <tspan x="0" y="0" riot-style="{`fill: ${this.getLinePreviewColor(\'both\')}`}">&#xe901;</tspan> </textPath> </text> </svg> </div> </span> </li> </ul>',
  '',
  'ref="main" class="hidden" riot-style="{this.getStyle()}" onmouseenter="{this.handlePanelMouseEnter}"', function(opts) {
'use strict';

var _this = this;

var _relationshipUi = require('lib/relationship-ui');

var _delayHandler = require('lib/delay-handler');

canvas = opts.canvas;
canvas.linkDirectionMenu = this;
this.isOpen = false;
this.linkTag = null;
this.origin = null;
this.summon = function (_ref) {
  var linkTag = _ref.linkTag,
      referenceEl = _ref.referenceEl,
      positionToLeft = _ref.positionToLeft,
      origin = _ref.origin;

  var rect = referenceEl.getBoundingClientRect();
  _this.linkTag = linkTag;
  _this.positionToLeft = positionToLeft;
  _this.origin = origin;
  if (_this.fromOrigin('toolbar')) {
    _this.y = rect.bottom;
    _this.x = rect.left;
  } else {
    _this.y = rect.top;
    _this.x = rect.right;
    if (positionToLeft) {
      _this.x = window.innerWidth - rect.left;
    }
  }

  if (positionToLeft) {
    _this.style = 'position: fixed; top: ' + _this.y + 'px; right: ' + _this.x + 'px';
  } else {
    _this.style = 'position: fixed; top: ' + _this.y + 'px; left: ' + _this.x + 'px';
  }

  _this.refs.main.classList.add('visible');
  _this.refs.main.classList.remove('hidden');
  _this.isOpen = true;
  _this.update();
};

this.fromOrigin = function (name) {
  return _this.origin === name;
};

this.getStyle = function () {
  return _this.style;
};

this.hide = function () {
  _this.isOpen = false;
  _this.selected = null;
  _this.linkTag = null;
  _this.origin = null;
  _this.refs.main.classList.remove('visible');
  _this.refs.main.classList.add('hidden');
};

this.changeRDirection = function (direction) {
  var linkIds = [];
  if (_this.linkTag) {
    linkIds = [_this.linkTag.id];
  } else {
    linkIds = canvas.getSelectedLinks().map(function (l) {
      return l.id;
    });
  }
  if (linkIds) {
    _relationshipUi.rui.setLineDirection(direction, linkIds);
  }
  _this.update();
};

this.getSelectedLinkIds = function () {
  return canvas.getSelectedLinks().map(function (l) {
    return l.id;
  });
};

this.getLinePreviewStyle = function () {
  return 'solid';
  //return rui.getLinePreviewStyle( this.getSelectedLinkIds() );
};

this.getLinePreviewWidth = function () {
  return '2px';
  //return rui.getLinePreviewWidth( this.getSelectedLinkIds() );
};

this.getLinePreviewColor = function (direction) {
  if (_this.getSelectedLinkIds().length == 1) {
    var link = canvas.store.getLink(_this.getSelectedLinkIds()[0]);
    var linkDir = link.direction;
    if (linkDir == direction) {
      return '#0077f1';
    }
  }
  return '#8595a9';
};

this.handlePanelMouseEnter = function () {
  _delayHandler.delayHandler.clearDelayFor('submenus');
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('link-direction-menu')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/link-direction-menu.html
// module id = 677
// module chunks = 0